module.exports = __webpack_public_path__ + "static/media/safeauto-round.e11199d9.png";